import React from 'react';
import styled, { css, keyframes } from 'styled-components';

export interface LoaderProps {
  children?: React.ReactNode;
  className?: string;
  color?: string;
  isLoading: boolean;
  size?: number;
}

const LOADER_DEFAULT_SIZE = 30;

const Loader = ({
  children,
  className,
  color,
  isLoading,
  size = LOADER_DEFAULT_SIZE,
}: LoaderProps) =>
  isLoading ? (
    <LoaderContainer className={className}>
      <SpinnerContainer size={size}>
        <Spinner color={color} size={size} />
      </SpinnerContainer>
    </LoaderContainer>
  ) : (
    <>{children}</>
  );

const LOADER_BORDER_RATIO = 1 / 25;
const LOADER_MIN_BORDER = 2;

const rotateAnimation = keyframes`
  from { transform: rotate(0deg) }
    to { transform: rotate(360deg) }
`;

const getAnimation = () => css`
  ${rotateAnimation};
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const SpinnerContainer = styled.div<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
`;

const Spinner = styled.div<{ color?: string; size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
  border-top: ${({ size }) =>
      Math.max(size * LOADER_BORDER_RATIO, LOADER_MIN_BORDER)}px
    solid;
  border-color: ${({ theme, color }) => (color ? color : theme.colors.accent)};
  animation: ${() => getAnimation()};
  animation-duration: ${({ theme }) => theme.transitions.speed.slow};
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  overflow: hidden;
`;

export default Loader;
